// // src/Loan/LoanCard.jsx
// import React, { useEffect, useState, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { data, useLocation, useParams } from "react-router-dom";
// import { fetchLoanEmis, clearLoanEmis } from "../redux/slices/loan/loanEmiSlice";
// import { fetchAllLoans } from "../redux/slices/loan/loanReportSlice";
// import jsPDF from "jspdf";
// import Barcode from "react-barcode";
// import html2canvas from "html2canvas";
// import "../assets/Loan/LoanCard.css";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// // Utils
// const formatDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const date = new Date(dateStr);
//   return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
// };
// const formatAmount = (amount) =>
//   !amount ? "Rs 0" : `Rs ${Number(amount).toLocaleString("en-IN")}`;

// const LoanCard = () => {
//   const { loanId } = useParams();
//   const dispatch = useDispatch();
//   const cardRef = useRef();
//   const location = useLocation();
//   const currentuserid= location.state?.loan;
//   // console.log("currenet user id",currentuserid);

//   const { emis, loading: emiLoading, error: emiError } = useSelector(
//     (state) => state.loanEmi
//   );

//   // console.log(emis);
//   const { loans, loading: loanLoading, error: loanError } = useSelector(
//     (state) => state.loanReport
//   );
//   const { profile } = useSelector((state) => state.userProfile);

//   const [company, setCompany] = useState(null);
//   const [photoUrl, setPhotoUrl] = useState(null);
//   const [customerDetails,setCustomerDetails]=useState(null);

//   const createdById = Number(localStorage.getItem("userId")) || 0;

//   // ✅ Fetch Profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // ✅ Fetch Loan + Company
//   useEffect(() => {

//     if (loanId) {
//       dispatch(fetchLoanEmis(loanId));
//       if (loans.length === 0) dispatch(fetchAllLoans());
//     }

//     const fetchCompany = async () => {
//       try {
//         const res = await fetch(
//           `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
//         );
//         const data = await res.json();
//         if (res.ok && data) {
//           if (data.logo) {
//             data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//           }
//           if(data.qrCodeImage){
//             data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
//           }
//           setCompany(data);
//         }
//       } catch (err) {
//         console.error("Error fetching company:", err);
//       }
//     };
//     if (profile?.superAdminId) fetchCompany();

//     return () => dispatch(clearLoanEmis());
//   }, [dispatch, loanId, loans.length, profile?.superAdminId]);

//   const loan = loans.find((l) => String(l.id) === String(loanId)) || null;
//   const emiAmountFromSchedule = emis?.[0]?.emiAmount || "NA";
//   // const branchId=emis?.[0]?.branchId || 0;

//   // ✅ Fetch Customer Photo (filtered by 'photo' docName)
//   useEffect(() => {

//           const branchId = Number(localStorage.getItem("userId")) || 0;

//     const fetchCustomerDetails = async () => {
//        try {
//             const res = await fetch(
//               `https://payyug.in/api/customers-get-userId?userId=${loan.customerId}&branchId=${branchId}`
//             );

//             const data = await res.json();
//              console.log("Customer API Response:", data);
//             setCustomerDetails(data.data);
//           } catch (err) {
//             console.error("Customer fetch error:", err);
//           }
//     };
//     const fetchCustomerPhoto = async () => {
//       try {
//         if (loan?.customerId && profile?.superAdminId) {
//           const res = await fetch(
//             `https://payyug.in/api/list-kyc?userId=${loan.customerId}&superAdminId=${profile.superAdminId}&createdId=${profile.id}`
//           );
//           const data = await res.json();
//           if (res.ok && data.documents?.length > 0) {
//             const photoDoc = data.documents.find(
//               (doc) => doc.docName?.toLowerCase() === "photo"
//             );
//             if (photoDoc?.docImage) {
//               setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
//             }
//           }
//         }
//       } catch (err) {
//         console.error("Failed to fetch customer photo:", err);
//       }
//     };
//     fetchCustomerDetails();
//     fetchCustomerPhoto();
//   }, [loan?.customerId, profile?.superAdminId, createdById]);

// // const generatePDF = async () => {
// //   const input = cardRef.current;
// //   if (!input) return;

// //   const pdf = new jsPDF("p", "mm", "a4");
// //   const pageWidth = pdf.internal.pageSize.getWidth();
// //   const pageHeight = pdf.internal.pageSize.getHeight();

// //   const canvas = await html2canvas(input, {
// //     scale: 2,
// //     useCORS: true,
// //     allowTaint: true,
// //     scrollY: -window.scrollY,
// //   });

// //   const imgWidth = pageWidth - 20;      // 10mm left + 10mm right margin
// //   const pageImageHeight = pageHeight - 20; // 10mm top + 10mm bottom margin

// //   const totalImageHeight = (canvas.height * imgWidth) / canvas.width;

// //   let renderedHeight = 0;

// //   while (renderedHeight < totalImageHeight) {

// //     // CREATE TEMPORARY CANVAS FOR EACH PAGE
// //     const pageCanvas = document.createElement("canvas");
// //     pageCanvas.width = canvas.width;
// //     pageCanvas.height =
// //       (pageImageHeight * canvas.width) / imgWidth;

// //     const ctx = pageCanvas.getContext("2d");

// //     // COPY PART OF FULL IMAGE → PAGE IMAGE
// //     ctx.drawImage(
// //       canvas,
// //       0,
// //       (renderedHeight * canvas.width) / imgWidth,
// //       canvas.width,
// //       pageCanvas.height,
// //       0,
// //       0,
// //       canvas.width,
// //       pageCanvas.height
// //     );

// //     const pageImgData = pageCanvas.toDataURL("image/png");
// //     const pageImgHeight = (pageCanvas.height * imgWidth) / canvas.width;

// //     if (renderedHeight === 0) {
// //       // FIRST PAGE
// //       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
// //     } else {
// //       // OTHER PAGES
// //       pdf.addPage();
// //       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
// //     }

// //     renderedHeight += pageImageHeight;
// //   }

// //   pdf.save(`LoanCard_${loan?.loanAccountNumber || loan?.loanNumber}.pdf`);
// // };

// const generatePDF = async () => {
//   const input = cardRef.current;
//   if (!input) return;

//   const pdf = new jsPDF("p", "mm", "a4");
//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();

//   // Set margins (10mm is standard)
//   const margin = 10;
//   const contentWidth = pageWidth - (margin * 2);
//   const contentHeight = pageHeight - (margin * 2);

//   const canvas = await html2canvas(input, {
//     scale: 2, // Keeps text sharp
//     useCORS: true,
//     backgroundColor: "#ffffff",
//     scrollY: -window.scrollY,
//   });

//   const imgWidth = canvas.width;
//   // Calculate how many pixels of the canvas fit into one PDF page
//   const pixelPageHeight = (imgWidth * contentHeight) / contentWidth;

//   let heightLeft = canvas.height;
//   let sY = 0; // Source Y position on the canvas

//   while (heightLeft > 0) {
//     // Determine the height of the slice for this page
//     const sHeight = Math.min(heightLeft, pixelPageHeight);

//     const pageCanvas = document.createElement("canvas");
//     pageCanvas.width = imgWidth;
//     pageCanvas.height = sHeight;

//     const ctx = pageCanvas.getContext("2d");
//     ctx.drawImage(
//       canvas,
//       0, sY,         // Source X, Y
//       imgWidth, sHeight, // Source Width, Height
//       0, 0,          // Destination X, Y
//       imgWidth, sHeight  // Destination Width, Height
//     );

//     const pageImgData = pageCanvas.toDataURL("image/jpeg", 1.0);

//     // Calculate the display height in mm for the PDF
//     const displayHeight_mm = (sHeight * contentWidth) / imgWidth;

//     if (sY > 0) pdf.addPage();

//     pdf.addImage(
//       pageImgData,
//       "JPEG",
//       margin,
//       margin,
//       contentWidth,
//       displayHeight_mm
//     );

//     // Update trackers
//     sY += sHeight;
//     heightLeft -= sHeight;
//   }

//   pdf.save(`LoanCard_${loan?.loanAccountNumber || loan?.loanNumber}.pdf`);
// };

// console.log("emis",emis)

//   if (loanLoading || emiLoading)
//     return <div className="branch-loan-card-container">Loading...</div>;
//   if (loanError || emiError)
//     return (
//       <div className="branch-loan-card-container">{loanError || emiError}</div>
//     );
//   if (!loan)
//     return (
//       <div className="branch-loan-card-container">
//         No loan found for Loan ID {loanId}
//       </div>
//     );

//   return (
//     <div>
//       <div className="branch-loan-card-container" ref={cardRef}>
//         {/* Header */}
//         <header className="branch-loan-card-header">
//           <div className="branch-loan-card-logo-box">
//             {company?.logoUrl && (
//               <img
//                 src={company.logoUrl}
//                 alt="Logo"
//                 className="branch-loan-card-logo"
//               />
//             )}
//           </div>

//           <div className="branch-loan-card-details-box">
//             <h2>{company?.name || "Company Name"}</h2>
//             <p>
//               <strong>CIN:</strong> {company?.cin || "-"}
//               <br />
//              {/* <strong>Regt. Office:</strong>*/} {company?.address || "-"}
//               {/* <b>Regt. Office:</b> {company?.ddress || "weriyfbup qcpqrhopwinhqguoq cwheruip chpefuib cuw hfwoeicf wperuoi hwe[cfio weuipfhwc[ rhwrfhewhfodhf jwoie rhfewoif ov "} */}
//               <br />
//               <strong>Website:</strong> {company?.domain || "-"}
//               <br />
//               <strong>Contact:</strong> {company?.contact || "-"}
//               <br />
//               <strong>Email:</strong> {company?.email || "-"}
//             </p>
//           </div>

//           <div className="branch-loan-card-qr-box">
//             <img
//               // src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${loanId}`}
//               src={company?.qrCodeUrl}
//               alt="QR Code"
//               className="branch-loan-card-qr"
//             />
//           </div>

//         </header>

//         {/* Title */}
//         <div className="branch-loan-card-title-section">
//           <div className="branch-loan-card-barcode-top">
//             <Barcode
//               value={loanId}
//               height={40}
//               displayValue={true}
//               fontSize={14}
//               margin={0}
//             />
//           </div>
//           <h3 className="branch-loan-card-title">Loan EMI Card</h3>
//         </div>

//         {/* Loan & Customer Details */}
//         <div className="branch-loan-card-loan-details">
//           <table className="branch-loan-card-detail-table">
//             <tbody>
//               <tr>
//                 <td>
//                   <strong>Customer Name:</strong> {loan.userName || "-"}
//                 </td>
//                 <td>
//                   <strong>Loan ID:</strong>{" "}
//                   {loan.loanAccountNumber || loan.loanNumber}
//                 </td>
//                 <td rowSpan="4" className="branch-loan-card-photo-cell">
//                   <img
//                     src={
//                       photoUrl ||
//                       "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
//                     }
//                     alt="Customer"
//                     className="branch-loan-card-photo"
//                   />
//                 </td>
//               </tr>
//               {/* <tr>
//                 <td>
//                   <strong>Contact No:</strong> {loan.contactNo || "-"}
//                 </td>
//                 <td>
//                   <strong>Guardian Name:</strong> {loan.guardianName || "-"}
//                 </td>
//               </tr> */}
//               <tr>
//                 <td>
//                   <strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}
//                 </td>
//                 <td>
//                   <strong>Plan Name:</strong>{" "}
//                   {loan.loanService || loan.loanService || "-"}
//                 </td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Number of EMI:</strong> {emis.length}
//                 </td>
//                 <td>
//                   <strong>EMI Amount:</strong>{" "}
//                   {formatAmount(emiAmountFromSchedule)}
//                 </td>
//               </tr>
//                <tr>
//                 <td colSpan={2}>
//                   <strong>Address: </strong>{customerDetails?.address}
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           <div className="branch-loan-card-branch-info">
//             <p>
//               <strong>Branch : </strong> {profile?.branchName || "-"}
//             </p>
//             <p>
//               <strong>Date : </strong> {new Date().toLocaleDateString("en-GB")}
//             </p>
//           </div>
//         </div>

//         {/* EMI Table */}
//         <section className="branch-loan-card-table-section">
//           <h4>EMI Schedule Terms</h4>
//           <table className="branch-loan-card-table">
//             <thead>
//               <tr>
//                 <th>Sr. No</th>
//                 <th>Loan EMI Date</th>
//                {loan?.loanType==="personal" && (
//                 <>
//                 <th>Interest</th>
//                 <th>Principal</th>
//                 </>
//                )}
//                 <th>EMI</th>
//                 <th>Receiving Date</th>
//                 <th>Received Amt</th>
//                 <th>Staff Sign</th>
//                 <th>Member Sign</th>
//               </tr>
//             </thead>
//             <tbody>
//               {emis.map((emi, idx) => (
//                 <tr key={idx}>
//                   <td>{idx + 1}</td>
//                   <td>{formatDate(emi.dueDate)}</td>
//                   {loan?.loanType==="personal" && (
//                 <>
//                  <td>{formatAmount(emi.interestComponent)}</td>
//                   <td>{formatAmount(emi.principalComponent)}</td>
//                 </>
//                )}
//                   <td>{formatAmount(emi.emiAmount)}</td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </section>

//         {/* Footer */}
//         <footer className="branch-loan-card-footer">
//           <div>
//             Member Signature
//             <br />
//             (सदस्य के हस्ताक्षर)
//           </div>
//           <div>
//             Spouse Signature
//             <br />
//             (जीवनसाथी के हस्ताक्षर)
//           </div>

//           <div>
//             Branch Seal With Signature
//             <br />
//             (शाखा मोहर के साथ हस्ताक्षर)
//           </div>
//         </footer>
//       </div>

//       {/* PDF Button */}
//       <div style={{ textAlign: "center" }}>
//         <button onClick={generatePDF} className="branch-loan-card-download-btn">
//           📄 Download PDF
//         </button>
//       </div>
//     </div>
//   );
// };
// export default LoanCard;

// src/Loan/LoanCard.jsx
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fetchLoanEmis,
  clearLoanEmis,
} from "../redux/slices/loan/loanEmiSlice";
import { fetchAllLoans } from "../redux/slices/loan/loanReportSlice";
import jsPDF from "jspdf";
import Barcode from "react-barcode";
import html2canvas from "html2canvas";
import "../assets/Loan/LoanCard.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";

// Utils
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
};

const formatAmount = (amount) =>
  !amount ? "₹0" : `₹${Number(amount).toLocaleString("en-IN")}`;

const getPublicImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (typeof imagePath === "object") {
    imagePath =
      imagePath.url ||
      imagePath.path ||
      imagePath.file ||
      imagePath.docImage ||
      imagePath.image;
  }
  if (!imagePath) return null;
  if (/^(https?:|data:|blob:)/i.test(imagePath)) return imagePath;

  const cleanPath = String(imagePath).replace(/^\/+/, "");
  if (cleanPath.startsWith("images/uploads/")) {
    return `https://payyug.in/uploads/${cleanPath.replace(/^images\/uploads\//, "")}`;
  }
  if (cleanPath.startsWith("uploads/")) {
    return `https://payyug.in/${cleanPath}`;
  }
  if (cleanPath.startsWith("images/")) {
    return `https://payyug.in/${cleanPath.replace(/^images\//, "")}`;
  }

  return `https://payyug.in/uploads/${cleanPath}`;
};

const getCustomerKycImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (typeof imagePath === "object") {
    imagePath =
      imagePath.docImage ||
      imagePath.fileUrl ||
      imagePath.filePath ||
      imagePath.url ||
      imagePath.path ||
      imagePath.file;
  }
  if (!imagePath) return null;
  if (/^(https?:|data:|blob:)/i.test(imagePath)) return imagePath;
  const cleanPath = String(imagePath).replace(/^\/+/, "");
  if (cleanPath.startsWith("uploads/")) return `https://payyug.in/${cleanPath}`;
  return `https://payyug.in/uploads/${cleanPath}`;
};

const LoanCard = () => {
  const { loanId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cardRef = useRef();
  const location = useLocation();

  const {
    emis,
    loading: emiLoading,
    error: emiError,
  } = useSelector((state) => state.loanEmi);
  const {
    loans,
    loading: loanLoading,
    error: loanError,
  } = useSelector((state) => state.loanReport);
  const { profile } = useSelector((state) => state.userProfile);

  const [company, setCompany] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [branchSealUrl, setBranchSealUrl] = useState(null);
  const [branchSignUrl, setBranchSignUrl] = useState(null);

  const createdById = Number(localStorage.getItem("userId")) || 0;

  // ✅ Fetch Profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // ✅ Fetch Loan + Company
  useEffect(() => {
    if (loanId) {
      dispatch(fetchLoanEmis(loanId));
      if (loans.length === 0) dispatch(fetchAllLoans());
    }

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          if (data.qrCodeImage) {
            data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      }
    };
    if (profile?.superAdminId) fetchCompany();

    return () => dispatch(clearLoanEmis());
  }, [dispatch, loanId, loans.length, profile?.superAdminId]);

  const loan = loans.find((l) => String(l.id) === String(loanId)) || null;
  const emiAmountFromSchedule = emis?.[0]?.emiAmount || "NA";
  const isPersonalLoan =
    (loan?.loanType || "").replace(/\s+loan$/i, "").trim().toLowerCase() ===
    "personal";
  const customerLookupIds = [
    loan?.customerId || loan?.customer?.userId || loan?.member?.userId,
  ]
    .filter(Boolean)
    .map(String);
  const customerLookupId = customerLookupIds[0];
  const embeddedCustomer = loan?.customer || loan?.member || {};
  const embeddedCustomerId =
    embeddedCustomer.userId || embeddedCustomer.customerId || embeddedCustomer.id;
  const customerRecord = {
    ...(embeddedCustomerId && String(embeddedCustomerId) === customerLookupId
      ? embeddedCustomer
      : {}),
    ...Object.fromEntries(
      Object.entries(customerDetails || {}).filter(
        ([, value]) => value !== null && value !== undefined && value !== "",
      ),
    ),
  };
  const scheduleColumns =
    emis.length > 30 ? [emis.slice(0, 30), emis.slice(30, 60)] : [emis];
  const memberSignatureSource =
    customerRecord?.signatureImage ||
    customerRecord?.signature ||
    customerRecord?.signImage ||
    signatureUrl ||
    loan?.memberSignature ||
    loan?.customerSignature ||
    loan?.memberSignatureImage ||
    loan?.signatureImage ||
    loan?.signImage;

  // Fetch customer profile and its uploaded KYC images.
  useEffect(() => {
    if (!customerLookupId) return;

    let isCurrentLoan = true;
    const branchId = Number(localStorage.getItem("userId")) || 0;
    setPhotoUrl(null);
    setSignatureUrl(null);
    setCustomerDetails(null);

    const fetchCustomerDetails = async () => {
      try {
        const readCustomer = async (lookupId, includeBranch) => {
          const params = new URLSearchParams({ userId: lookupId });
          if (includeBranch && branchId) params.set("branchId", String(branchId));
          const res = await fetch(
            `https://payyug.in/api/customers-get-userId?${params}`,
          );
          const data = await res.json();
          const details = Array.isArray(data?.data)
            ? data.data[0]
            : data?.data?.customer ||
              data?.customer ||
              data?.data?.account ||
              data?.data;
          if (!res.ok || !details || !Object.keys(details).length) return null;
          const returnedIds = [details.userId, details.customerId, details.id]
            .filter((id) => id !== null && id !== undefined)
            .map(String);
          return returnedIds.includes(lookupId) ? details : null;
        };
        let details = null;
        for (const lookupId of customerLookupIds) {
          details =
            (await readCustomer(lookupId, true)) ||
            (await readCustomer(lookupId, false));
          if (details) break;
        }
        if (!details || !isCurrentLoan) return;
        setCustomerDetails(details);
        const directPhoto =
          details?.customerPhoto ||
          details?.photo ||
          details?.photoUrl ||
          details?.profileImage ||
          details?.customerImage ||
          details?.avatar ||
          details?.image;
        if (directPhoto && isCurrentLoan) {
          setPhotoUrl(getPublicImageUrl(directPhoto));
        }
      } catch (err) {
        console.error("Customer fetch error:", err);
      }
    };

    const fetchCustomerKycImages = async () => {
      try {
        const readDocuments = async ({ userId, createdId, includeSuperAdmin = true }) => {
          const params = new URLSearchParams({ userId });
          if (includeSuperAdmin && profile?.superAdminId) {
            params.set("superAdminId", String(profile.superAdminId));
          }
          if (createdId) params.set("createdId", String(createdId));
          const res = await fetch(`https://payyug.in/api/list-kyc?${params}`);
          const data = await res.json();
          const documents = Array.isArray(data?.documents)
            ? data.documents
            : Array.isArray(data?.data?.documents)
              ? data.data.documents
              : Array.isArray(data?.data)
                ? data.data
                : [];
          return res.ok ? documents : [];
        };
        // CustomerKyc lists documents by the logged-in userId (`createdId`)
        // without requiring superAdminId; try that exact query first.
        const queryAttempts = [
          { userId: customerLookupId, createdId: branchId, includeSuperAdmin: false },
          { userId: customerLookupId, createdId: profile?.id, includeSuperAdmin: true },
        ];
        let documents = [];
        const attemptedQueries = new Set();
        for (const attempt of queryAttempts) {
          const queryKey = `${attempt.userId}:${attempt.createdId || ""}:${attempt.includeSuperAdmin}`;
          if (attemptedQueries.has(queryKey)) continue;
          attemptedQueries.add(queryKey);
          const foundDocuments = (await readDocuments(attempt)).filter((doc) => {
            const docUserId = doc?.userId || doc?.customerId || doc?.customer?.userId;
            return !docUserId || String(docUserId) === attempt.userId;
          });
          if (foundDocuments.length) {
            documents = [...documents, ...foundDocuments];
          }
          const names = documents.map((doc) =>
            String(doc?.docName || doc?.documentName || doc?.docType || doc?.documentType || doc?.type || doc?.name || "")
              .trim()
              .toLowerCase()
              .replace(/[\s_-]+/g, ""),
          );
          if (names.some((name) => /photo|photograph/.test(name)) &&
              names.some((name) => ["signature", "sign", "customersignature", "membersignature", "customersign", "membersign"].includes(name))) {
            break;
          }
        }
        if (!documents.length || !isCurrentLoan) return;

        const normalizeDocName = (doc) =>
          String(
            doc?.docName ||
              doc?.documentName ||
              doc?.docType ||
              doc?.documentType ||
              doc?.type ||
              doc?.name ||
              "",
          )
            .trim()
            .toLowerCase()
            .replace(/[\s_-]+/g, "");
        const imageFor = (doc) =>
          doc?.docImage ||
          doc?.file ||
          doc?.fileUrl ||
          doc?.filePath ||
          doc?.imageUrl ||
          doc?.imagePath ||
          doc?.image ||
          doc?.url;
        const photoDoc = documents.find((doc) =>
          /photo|photograph/.test(normalizeDocName(doc)),
        );
        const signatureDoc = documents.find((doc) =>
          ["signature", "sign", "customersignature", "membersignature", "customersign", "membersign"].includes(
            normalizeDocName(doc),
          ),
        );

        if (isCurrentLoan && imageFor(photoDoc)) {
          setPhotoUrl(getCustomerKycImageUrl(imageFor(photoDoc)));
        }
        if (isCurrentLoan && imageFor(signatureDoc)) {
          setSignatureUrl(getCustomerKycImageUrl(imageFor(signatureDoc)));
        }
      } catch (err) {
        console.error("Failed to fetch customer KYC images:", err);
      }
    };

    fetchCustomerDetails();
    fetchCustomerKycImages();
    return () => {
      isCurrentLoan = false;
    };
  }, [customerLookupId, profile?.superAdminId, profile?.id, createdById]);

  useEffect(() => {
    const fetchSealSign = async () => {
      if (!profile?.superAdminId) return;

      try {
        const res = await axios.get(
          `https://payyug.in/api/list/stamp?superAdminId=${profile?.superAdminId}&category=Loan Card`,
        );

        const responseData = res?.data?.data;
        const stampRecord = Array.isArray(responseData)
          ? responseData.flat(Infinity).find((record) => record && (record.file || record.type))
          : responseData?.data?.[0] || responseData;
        setBranchSealUrl(getPublicImageUrl(stampRecord?.file));
        setBranchSignUrl(getPublicImageUrl(stampRecord?.type || stampRecord?.signature || stampRecord?.sign));
      } catch (error) {
        console.error("API Fetch Error:", error);
      }
    };

    fetchSealSign();
  }, [profile?.superAdminId]);

  const generatePDF = async () => {
    const input = cardRef.current;
    if (!input) return;

    const downloadBtns = document.querySelectorAll(
      ".branch-loan-card-download-btn",
    );
    downloadBtns.forEach((btn) => (btn.style.display = "none"));

    try {
      await Promise.all(
        Array.from(input.querySelectorAll("img")).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        }),
      );
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        scrollY: -window.scrollY,
      });
      const pdf = new jsPDF("p", "mm", "a4", true);
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const maxWidth = pageWidth - margin * 2;
      const maxHeight = pageHeight - margin * 2;
      const scale = Math.min(maxWidth / canvas.width, maxHeight / canvas.height);
      const imageWidth = canvas.width * scale;
      const imageHeight = canvas.height * scale;

      pdf.addImage(
        canvas.toDataURL("image/jpeg", 0.95),
        "JPEG",
        (pageWidth - imageWidth) / 2,
        (pageHeight - imageHeight) / 2,
        imageWidth,
        imageHeight,
        undefined,
        "FAST",
      );
      pdf.save(`${loan?.userName || "Customer"}_LoanCard.pdf`);
    } catch (error) {
      console.error("PDF generation error:", error);
    } finally {
      downloadBtns.forEach((btn) => (btn.style.display = "inline-block"));
    }
  };

  const triggerPrintElement = async (elementRef, title = "Print_Document") => {
    const input = elementRef.current;
    if (!input) return;

    try {
      await Promise.all(
        Array.from(input.querySelectorAll("img")).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        }),
      );
      const canvas = await html2canvas(input, {
        scale: 1.5,
        useCORS: true,
        backgroundColor: "#ffffff",
        scrollY: -window.scrollY,
      });
      const imageUrl = canvas.toDataURL("image/jpeg", 0.95);
      document.getElementById("personal-loan-print-frame")?.remove();

      const iframe = document.createElement("iframe");
      iframe.id = "personal-loan-print-frame";
      iframe.style.cssText = "position:fixed;inset:0;width:100vw;height:100vh;border:0;z-index:2147483647";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <!DOCTYPE html>
        <html><head><title></title><style>
          @page { size: A4 portrait; margin: 0; }
          html, body { width: 210mm; height: 297mm; margin: 0; padding: 0; overflow: hidden; background: #fff; print-color-adjust: exact; }
          img { display: block; width: 200mm; height: 287mm; margin: 5mm auto; object-fit: contain; print-color-adjust: exact; }
        </style></head><body><img id="personal-loan-print-card" alt="Personal loan card"></body></html>
      `);
      doc.close();
      doc.title = title;

      const printImage = doc.getElementById("personal-loan-print-card");
      printImage.onload = () => {
        const appRoot = document.getElementById("root");
        const previousRootVisibility = appRoot?.style.visibility;
        const previousTitle = document.title;
        let cleanedUp = false;
        const cleanup = () => {
          if (cleanedUp) return;
          cleanedUp = true;
          document.title = previousTitle;
          if (appRoot) appRoot.style.visibility = previousRootVisibility;
          iframe.remove();
        };
        if (appRoot) appRoot.style.visibility = "hidden";
        iframe.contentWindow.onafterprint = cleanup;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          document.title = title;
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        }));
      };
      printImage.onerror = () => iframe.remove();
      printImage.src = imageUrl;
    } catch (error) {
      console.error("Print generation error:", error);
    }
  };

  const handlePrint = () => {
    triggerPrintElement(cardRef, `${loan?.userName || "Customer"}_LoanCard`);
  };

  if (loanLoading || emiLoading)
    return <div className="branch-loan-card-container">Loading...</div>;
  if (loanError || emiError)
    return (
      <div className="branch-loan-card-container">{loanError || emiError}</div>
    );
  if (!loan)
    return (
      <div className="branch-loan-card-container">
        No loan found for Loan ID {loanId}
      </div>
    );

  return (
    <div className="loan-card-page-shell">
      <div className="loan-card-top-actions">
        <button
          onClick={() => navigate(-1)}
          className="branch-loan-card-download-btn loan-card-back-btn"
          style={{ cursor: "pointer" }}
        >
          ← Back
        </button>
      </div>

      <div
        className="branch-loan-card-container loan-card-redesign personal-loan-card"
        ref={cardRef}
      >
        {/* Header */}
        <header className="branch-loan-card-header">
          <div className="branch-loan-card-logo-box">
            {company?.logoUrl && (
              <img
                src={company.logoUrl}
                alt="Logo"
                className="branch-loan-card-logo"
              />
            )}
          </div>

          <div className="branch-loan-card-details-box">
            <h2>{company?.name || "Company Name"}</h2>
            <p>
              <strong>CIN:</strong> {company?.cin || "-"}
              <br />
              {company?.address || "-"}
              <br />
              <strong>Website:</strong> {company?.domain || "-"}
              <br />
              <strong>Contact:</strong> {company?.contact || "-"}
              <br />
              <strong>Email:</strong> {company?.email || "-"}
            </p>
          </div>

          <div className="branch-loan-card-qr-box">
            <img
              src={company?.qrCodeUrl}
              alt="QR Code"
              className="branch-loan-card-qr"
            />
          </div>
        </header>

        {/* Title */}
        <div className="branch-loan-card-title-section">
          <div className="branch-loan-card-barcode-top">
            <Barcode
              value={loanId}
              height={40}
              displayValue={true}
              fontSize={14}
              margin={0}
            />
          </div>
          <h3 className="branch-loan-card-title">
            {(loan.loanType || "Personal")
              .replace(/\s+loan$/i, "")
              .toUpperCase()}{" "}
            LOAN EMI CARD
          </h3>
        </div>

        {/* Loan & Customer Details */}
        <div className="branch-loan-card-meta-row">
          <div>
            <p>
              <strong>Customer Name:</strong>{" "}
              {customerDetails?.fullName ||
                customerDetails?.name ||
                loan.userName ||
                "-"}
            </p>
            <p>
              <strong>Account Number:</strong>{" "}
              {loan.loanAccountNumber || loan.loanNumber || "-"}
            </p>
          </div>
          <div>
            <p>
              <strong>Branch:</strong> {profile?.branchName || "-"}
            </p>
            <p>
              <strong>Date:</strong>{" "}
              {loan?.disbursalDate
                ? new Date(loan.disbursalDate).toLocaleDateString("en-GB")
                : new Date().toLocaleDateString("en-GB")}
            </p>
          </div>
        </div>

        <section className="branch-loan-card-loan-details">
          <div className="branch-loan-card-section-heading">
            Loan &amp; Customer Details
          </div>
          <div className="branch-loan-card-overview-grid">
            <div className="branch-loan-card-overview-fields">
              <div className="branch-loan-card-field">
                <strong>Customer ID</strong>
                <span>
                  {customerRecord?.userId ||
                    customerRecord?.customerId ||
                    loan.customerId ||
                    "-"}
                </span>
              </div>
              <div className="branch-loan-card-field">
                <strong>Father / Spouse</strong>
                <span>
                  {customerRecord?.fatherName ||
                    customerRecord?.fatherOrSpouse ||
                    customerRecord?.spouseName ||
                    customerRecord?.husbandName ||
                    customerRecord?.guardianName ||
                    loan.fatherName ||
                    loan.spouseName ||
                    loan.guardianName ||
                    "-"}
                </span>
              </div>
              <div className="branch-loan-card-field">
                <strong>Mobile</strong>
                <span>
                  {customerRecord?.mobileNumber || loan.mobileNumber || "-"}
                </span>
              </div>
              <div className="branch-loan-card-field">
                <strong>Form Number</strong>
                <span>
                  {loan.formNo ||
                    loan.formNumber ||
                    loan.loanAccountNumber ||
                    "-"}
                </span>
              </div>
              <div className="branch-loan-card-field">
                <strong>Loan Type</strong>
                <span>
                  {loan.loanType
                    ? `${loan.loanType.charAt(0).toUpperCase()}${loan.loanType.slice(1).toLowerCase()}`
                    : "-"}
                </span>
              </div>
              <div className="branch-loan-card-field">
                <strong>Loan Amount</strong>
                <span>{formatAmount(loan.loanAmount)}</span>
              </div>
              <div className="branch-loan-card-field">
                <strong>EMI Amount</strong>
                <span>{formatAmount(emiAmountFromSchedule)}</span>
              </div>
              <div className="branch-loan-card-field">
                <strong>No. of EMI</strong>
                <span>{emis.length || "-"}</span>
              </div>
              <div className="branch-loan-card-field branch-loan-card-field-wide">
                <strong>Address</strong>
                <span>
                  {customerRecord?.address ||
                    customerRecord?.fullAddress ||
                    loan.address ||
                    loan.customer?.address ||
                    loan.member?.address ||
                    "-"}
                </span>
              </div>
              <div className="branch-loan-card-field">
                <strong>Interest Rate</strong>
                <span>{loan.loanRoi || loan.interestRate || "-"}%</span>
              </div>
            </div>
            <div className="branch-loan-card-photo-cell">
              <strong>Customer Photo</strong>
              <img
                src={
                  photoUrl ||
                  getPublicImageUrl(
                    customerRecord?.customerPhoto ||
                      customerRecord?.photo ||
                      customerRecord?.photoUrl ||
                      customerRecord?.profileImage ||
                      customerRecord?.customerImage ||
                      customerRecord?.avatar,
                  ) ||
                  "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
                }
                alt="Customer"
                className="branch-loan-card-photo"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src =
                    "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg";
                }}
              />
            </div>
          </div>
        </section>

        {/* EMI Table */}
        <section className="branch-loan-card-table-section">
          <h4>EMI Repayment Schedule (Total {emis.length} EMIs)</h4>
          <div
            className={`branch-loan-card-schedule-columns${scheduleColumns.length === 1 ? " single-column" : ""}`}
          >
            {scheduleColumns.map((schedule, columnIndex) => (
              <table className="branch-loan-card-table" key={columnIndex}>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Loan EMI Date</th>
                    <th>EMI (₹)</th>
                    {isPersonalLoan && <>
                      <th>Principal</th>
                      <th>Interest</th>
                      <th>Outstanding</th>
                    </>}
                    <th>Receiving Date</th>
                    <th>Received Amt</th>
                    <th>Staff Sign</th>
                    <th>Member Sign</th>
                  </tr>
                </thead>
                <tbody>
                  {schedule.map((emi, index) => {
                    const installmentNo = columnIndex * 30 + index + 1;
                    const paymentAmounts = [1, 2, 3, 4, 5]
                      .map((paymentNo) => Number(emi[`payment${paymentNo}`]) || 0)
                      .filter((amount) => amount > 0);
                    const receivedAmount = emi.paidAmount ?? emi.lastPaidAmount ?? emi.partiallyPaidAmount ??
                      (paymentAmounts.length ? paymentAmounts.reduce((sum, amount) => sum + amount, 0) : null);
                    const receivedDate = emi.paidDate || emi.lastPaidDate ||
                      [5, 4, 3, 2, 1].map((paymentNo) => emi[`payment${paymentNo}Date`]).find(Boolean);
                    const principalPaidToDate = emis
                      .slice(0, columnIndex * 30 + index + 1)
                      .reduce(
                        (total, scheduledEmi) =>
                          total + (Number(scheduledEmi.principalComponent) || 0),
                        0,
                      );
                    const outstanding =
                      emi.outstandingBalance ??
                      emi.outstandingAmount ??
                      Math.max(0, (Number(loan.loanAmount) || 0) - principalPaidToDate);
                    return (
                      <tr key={emi.id || installmentNo} className="print-row">
                        <td>{emi.installmentNo || installmentNo}</td>
                        <td>{formatDate(emi.dueDate)}</td>
                        <td>{formatAmount(emi.emiAmount)}</td>
                        {isPersonalLoan && <>
                          <td>{formatAmount(emi.principalComponent)}</td>
                          <td>{formatAmount(emi.interestComponent)}</td>
                          <td>{formatAmount(outstanding)}</td>
                        </>}
                        <td>{receivedDate ? formatDate(receivedDate) : ""}</td>
                        <td>{receivedAmount !== null && receivedAmount !== undefined && receivedAmount !== "" ? formatAmount(receivedAmount) : ""}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ))}
          </div>
        </section>

        {/* Footer Block Wrapper */}
        <footer className="branch-loan-card-footer print-row">
          <div className="box-size">
            <strong className="branch-loan-card-signature-title">Member Signature</strong>
            <span className="branch-loan-card-signature-hindi">(सदस्य के हस्ताक्षर)</span>
            <div className="branch-loan-card-signature-slot">
              {memberSignatureSource ? (
                <img
                  src={getPublicImageUrl(memberSignatureSource)}
                  alt="Member signature"
                  className="branch-loan-card-footer-signature"
                />
              ) : (
                <span className="branch-loan-card-signature-missing">
                  Signature not uploaded
                </span>
              )}
            </div>
          </div>
          <div className="box-size">
            <strong className="branch-loan-card-signature-title">Co-Borrower Signature</strong>
            <span className="branch-loan-card-signature-hindi">(सह-उधारकर्ता के हस्ताक्षर)</span>
            <div className="branch-loan-card-signature-slot">
              {(loan?.coBorrowerSignature || loan?.coBorrowerSignatureImage || loan?.guarantorSignature) && (
                <img
                  src={getPublicImageUrl(loan.coBorrowerSignature || loan.coBorrowerSignatureImage || loan.guarantorSignature)}
                  alt="Co-borrower signature"
                  className="branch-loan-card-footer-signature"
                />
              )}
            </div>
          </div>
          <div className="box-size">
            <strong className="branch-loan-card-signature-title">President / Secretary Signature</strong>
            <span className="branch-loan-card-signature-hindi">(अध्यक्ष / सचिव के हस्ताक्षर)</span>
            <div className="branch-loan-card-signature-slot">
              {branchSignUrl && (
                <img
                  src={branchSignUrl}
                  alt="President or secretary signature"
                  className="branch-loan-card-footer-signature"
                />
              )}
            </div>
          </div>
          <div className="footer-seal-sign box-size">
            <strong className="branch-loan-card-signature-title">Branch Seal &amp; Signature</strong>
            <span className="branch-loan-card-signature-hindi">(शाखा मोहर के साथ हस्ताक्षर)</span>
            <div className="branch-loan-card-branch-assets">
              <div className="branch-loan-card-seal-slot">
                {branchSealUrl && <img src={branchSealUrl} alt="Branch seal" />}
              </div>
              <div className="branch-loan-card-signature-slot">
                {branchSignUrl && <img src={branchSignUrl} alt="Branch signature" className="branch-loan-card-footer-signature" />}
              </div>
            </div>
          </div>
        </footer>

        <footer className="branch-loan-card-wave-footer">
          <div>
            {company?.name || "Loan Management System"} | CIN:{" "}
            {company?.cin || "N/A"} | Contact: {company?.contact || "N/A"}
          </div>
          <svg
            viewBox="0 0 500 80"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <path
              d="M0,80 L0,30 Q150,0 280,45 T500,20 L500,80 Z"
              fill="#38bdf8"
            />
            <path
              d="M0,80 L0,45 Q160,15 310,55 T500,35 L500,80 Z"
              fill="#0284c7"
            />
            <path
              d="M0,80 L0,55 Q180,25 340,65 T500,45 L500,80 Z"
              fill="#0f172a"
            />
          </svg>
        </footer>
      </div>

      {/* Action Buttons */}
      <div
        style={{
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          marginTop: "16px",
        }}
      >
        <button
          onClick={handlePrint}
          className="branch-loan-card-download-btn"
          style={{ cursor: "pointer" }}
        >
          🖨️ Print Card
        </button>

        <button
          onClick={generatePDF}
          className="branch-loan-card-download-btn"
          style={{ cursor: "pointer" }}
        >
          📄 Download PDF
        </button>
      </div>
    </div>
  );
};

export default LoanCard;
